export default __webpack_public_path__ + "media/images/features/local_delivery/local_delivery_icon-916928b54aca597dfc46aef4ea5eb009.png";